import React from 'react'
import './TestimonialCard.css'
import { makeStyles } from '@material-ui/core/styles';
import {API_URL} from '../../constants'

const useStyles = makeStyles((theme)=>({
    large:{
        width: theme.spacing(12),
        height: theme.spacing(12),
        top:- theme.spacing(12)/3,
    }
}))

export default function TCard({author,statement,photo_url}) {
    const classes = useStyles()
    console.log(photo_url)
    return (
        <div className="card-container">
            <span className="pro">*</span>

            <img className="round" src={API_URL +'/' + photo_url} alt="user"/>
            <h3>{author}</h3>
            <h6>avocat</h6>
            <p className={"card__article__text"}>
                {statement}
            </p>
            {/*<div className="buttons">*/}
            {/*    <button className="primary">*/}
            {/*        Message*/}
            {/*    </button>*/}
            {/*    <button className="primary ghost">*/}
            {/*        Following*/}
            {/*    </button>*/}
            {/*</div>*/}
            {/*<div className="skills">*/}
            {/*    <h6>Skills</h6>*/}
            {/*    <ul>*/}
            {/*        <li>UI / UX</li>*/}
            {/*        <li>Front End Development</li>*/}
            {/*        <li>HTML</li>*/}
            {/*        <li>CSS</li>*/}
            {/*        <li>JavaScript</li>*/}
            {/*        <li>React</li>*/}
            {/*        <li>Node</li>*/}
            {/*    </ul>*/}
            {/*</div>*/}
        </div>
    )
}
